// extracted by mini-css-extract-plugin
export default {"success":"success--eOVdq","alert":"alert--aV5Dr","error":"error--lAFOg","default":"default--Labdf"};